import * as React from "react"

function ApplePayIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 83 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <rect
                x={1.212}
                y={0.642}
                width={80.425}
                height={49.319}
                rx={5.5}
                fill="#fff"
            />
            <path
                d="M23.13 17.107c-.655.777-1.706 1.39-2.756 1.302-.131-1.05.383-2.167.985-2.856.656-.799 1.805-1.368 2.734-1.411.11 1.094-.317 2.166-.962 2.965zm.952 1.51c-1.52-.088-2.822.864-3.544.864-.733 0-1.837-.82-3.04-.799-1.565.022-3.02.909-3.818 2.32-1.641 2.823-.427 7.003 1.16 9.3.776 1.139 1.706 2.386 2.93 2.342 1.16-.043 1.62-.754 3.02-.754 1.411 0 1.816.754 3.04.733 1.27-.022 2.068-1.138 2.845-2.276.886-1.292 1.247-2.55 1.269-2.616-.022-.021-2.45-.951-2.472-3.753-.022-2.341 1.914-3.457 2.002-3.523-1.095-1.62-2.8-1.794-3.392-1.838zm8.784-3.173v17.058h2.647V26.67h3.665c3.347 0 5.699-2.298 5.699-5.624 0-3.326-2.308-5.602-5.612-5.602h-6.399zm2.647 2.232h3.052c2.297 0 3.61 1.225 3.61 3.38 0 2.156-1.313 3.393-3.62 3.393h-3.042v-6.773zm14.199 14.957c1.663 0 3.205-.842 3.905-2.177h.055v2.046h2.45v-8.49c0-2.463-1.969-4.05-4.999-4.05-2.811 0-4.89 1.61-4.966 3.82h2.385c.196-1.051 1.17-1.74 2.504-1.74 1.62 0 2.527.755 2.527 2.144v.941l-3.303.197c-3.074.186-4.737 1.445-4.737 3.633 0 2.21 1.718 3.676 4.179 3.676zm.71-2.024c-1.41 0-2.307-.678-2.307-1.718 0-1.072.864-1.696 2.516-1.794l2.942-.186v.963c0 1.597-1.356 2.735-3.15 2.735zm8.97 6.533c2.582 0 3.796-.985 4.857-3.972l4.65-13.043h-2.692L63.09 30.204h-.055l-3.117-10.077H57.15l4.485 12.419-.24.755c-.405 1.28-1.062 1.773-2.232 1.773-.208 0-.612-.022-.777-.044v2.046c.153.044.81.066 1.007.066z"
                fill="#000"
            />
            <rect
                x={1.212}
                y={0.642}
                width={80.425}
                height={49.319}
                rx={5.5}
                stroke="#CECECE"
            />
        </svg>
    )
}

export default ApplePayIcon
